const sliderBreakPoints = {
  2560: {
    slidesPerView: 'auto',
    spaceBetween: 32,
  },
  1200: {
    slidesPerView: 'auto',
    spaceBetween: 32,
  },
  960: {
    slidesPerView: 'auto',
    spaceBetween: 32,
  },
  720: {
    slidesPerView: 'auto',
    spaceBetween: 12,
  },
  540: {
    slidesPerView: 1,
    spaceBetween: 12,
  },
  320: {
    slidesPerView: 1,
    spaceBetween: 12,
  },
};

export default sliderBreakPoints;
